import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { signOut } from 'aws-amplify/auth';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-outer-header',
  templateUrl: './outer-header.component.html',
  styleUrls: ['./outer-header.component.scss'],
})
export class OuterHeaderComponent implements OnInit {
  userDetails: any;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.getUserDetails();
  }

  async getUserDetails() {
    this.userDetails = await this.authService.getUserInfo();
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['./login']);
  }

  home() {
    this.router.navigate(['./home']);
  }
}
